import script from "./BlogEditView.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogEditView.vue?vue&type=script&setup=true&lang=js"

import "./BlogEditView.vue?vue&type=style&index=0&id=b35033ec&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b35033ec"]])

export default __exports__